import cn from 'classnames';
import Image from 'next/image';

import getStartedImage from '@/public/images/blog/get-started.png';
import requestDemoImage from '@/public/images/blog/request-demo.png';
import Link from '@/components/link';
import ArrowSVG from '@/svg/icons/arrow.svg';

const link = [
  {
    href: `https://app.graphcms.com/signup`,
    title: `Get started`,
    description: `Create a free-forever developer account.`,
    color: `bg-purple-500 hover:bg-purple-600`,
    image: getStartedImage,
  },
  {
    href: `/contact`,
    title: `Request demo`,
    description: `Learn how GraphCMS can power your next project.`,
    color: `bg-indigo-rainbow hover:bg-zodiac`,
    image: requestDemoImage,
  },
];

export default function AsideCTACards({ className }: { className?: string }) {
  return (
    <div className={cn(`space-y-6`, className)}>
      {link.map(({ href, title, description, color, image }) => (
        <Link
          href={href}
          key={href}
          className={cn(
            `grid w-full h-full rounded-lg p-4 text-white transition-colors`,
            color,
          )}
        >
          <div>
            <h3 className="font-semibold flex items-center">
              <span>{title}</span>
              <ArrowSVG className="transform rotate-180 w-4 h-4 ml-2 fill-current" />
            </h3>
            <p className="text-xs mt-2 font-medium">{description}</p>
          </div>
          <div className="mt-6">
            <Image
              src={image}
              layout="responsive"
              width={148}
              height={100}
              objectFit="contain"
            />
          </div>
        </Link>
      ))}
    </div>
  );
}
